import { render, staticRenderFns } from "./Home_body.vue?vue&type=template&id=2374e602"
import script from "./Home_body.vue?vue&type=script&lang=js"
export * from "./Home_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports